<div class="u-shadow-mini {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }} {{ timezone }}</h5>
				<!-- <span class="sub-title">Impressions by Time of Day {{ timezone }}</span> -->
			</div>
		</div>
		<div class="analytics-portlet-content" style="position: relative; z-index: 0">
			<div *ngIf="hasData">
				<div class="daypart-details" *ngFor="let dayPart of dayPartArray; let j = index">
					<div class="daypart-left-section">{{ dayPart.name }}</div>
					<div class="daypart-right-section">
						<div
							class="daypart-css-graph"
							tooltip="<div class='daypart-tooltip'><div class='daypart-name'>{{
								dayPart.name
							}}</div><div class='daypart-friendly-name'>{{
								dayPart.friendly_name
							}}</div><div class='daypart-impressions'>Impressions: {{ dayPart.impressions | number }}</div></div>"
							[options]="tooltipOptions"
						>
							<div class="daypart-css-graph-data" [style.width.%]="dayPart.percentage"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="no-data-text" *ngIf="!hasData">No Data</div>
		</div>
	</div>
</div>
